<template>
    <div class="row mt-3">
        <div class="course-include d-inline-block mb-2 col-6">
            <div class="include-img d-inline-block">
                <i class="fas fa-home text-main-color fa-lg position-relative"></i>
            </div>
            <div class="include-info d-inline-block pr-2">
                <p class="mb-1">{{ tra.residence_age }}</p>
                <p class="text-main-color font-weight-bold mb-2">
                    {{ ageRangeDisplay(residence) }}
                </p>
            </div>
        </div>
        
        <div class="course-include d-inline-block mb-2 col-6">
            <div class="include-img d-inline-block">
                <i class="fas fa-home text-main-color fa-lg position-relative"></i>
            </div>
            <div class="include-info d-inline-block pr-2">
                <p class="mb-1">{{ tra.accommodation_type }}</p>
                <p class="text-main-color font-weight-bold mb-2">
                    {{ tra[residence.residence_type] }}
                </p>
            </div>
        </div>
        
        <div class="course-include d-inline-block mb-2 col-6">
            <div class="include-img d-inline-block">
                <i class="fas fa-bed text-main-color fa-lg position-relative"></i>
            </div>
            <div class="include-info d-inline-block pr-2">
                <p class="mb-1">{{ tra.room_type }}</p>
                <p class="text-main-color font-weight-bold mb-2">
                    {{ residence.room_type || '' }}
                </p>
            </div>
        </div>
        
        <div class="course-include d-inline-block mb-2 col-6">
            <div class="include-img d-inline-block">
                <i class="fas fa-bath text-main-color fa-lg position-relative"></i>
            </div>
            <div class="include-info d-inline-block pr-2">
                <p class="mb-1">{{ tra.bathroom_type }}</p>
                <p class="text-main-color font-weight-bold mb-2">
                    {{ residence.bath_type || '' }}
                </p>
            </div>
        </div>
        
        <div class="course-include d-inline-block mb-2 col-6">
            <div class="include-img d-inline-block">
                <i class="fas fa-utensils text-main-color fa-lg position-relative"></i>
            </div>
            <div class="include-info d-inline-block pr-2">
                <p class="mb-1">{{ tra.meals }}</p>
                <p v-if="residence.breakfast != null || residence.lunch != null || residence.dinner != null"
                   class="text-main-color font-weight-bold mb-2">
                    {{ residence.breakfast == 1 ? tra.breakfast : '' }}
                    {{ residence.lunch == 1 ? ", " + tra.lunch : '' }}
                    {{ residence.dinner == 1 ? ", " + tra.dinner : '' }}
                </p>
                <p v-else class="text-danger font-weight-bold">
                    {{ tra.not_available }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ResidenceDetails',
    props: {
        residence: {
            type: Object,
            required: true
        },
        tra: {
            type: Object,
            required: true
        }
    },
    methods: {
        ageRangeDisplay(residence) {
            if (!residence) return this.tra.not_specified || 'غير محدد';
            
            const { min_age, max_age } = residence;

            if (min_age == null && max_age == null) {
                return this.tra.not_specified || 'غير محدد';
            }
            if (min_age != null && max_age == null) {
                return `${this.tra.more_than || 'أكثر من'} ${min_age}`;
            }
            if (min_age == null && max_age != null) {
                return `${this.tra.less_than || 'أقل من'} ${max_age}`;
            }
            if (min_age == max_age) {
                return `${max_age}`;
            }
            return `${this.tra.from || 'من'} ${min_age} ${this.tra.to || 'إلى'} ${max_age}`;
        }
    }
};
</script>
